import { render, staticRenderFns } from "./DegreeImport.vue?vue&type=template&id=bee6c74a&scoped=true&"
import script from "./DegreeImport.vue?vue&type=script&lang=js&"
export * from "./DegreeImport.vue?vue&type=script&lang=js&"
import style0 from "./DegreeImport.vue?vue&type=style&index=0&id=bee6c74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee6c74a",
  null
  
)

export default component.exports